import React from 'react';
import ReactDOM from 'react-dom';
import './reset.css';
import Layout from './layout/';
import { formatImage, formatUrl } from '@ifeng-fe/public_method';
/* eslint-disable */
try {
    const shangxun = allData.shangxun && allData.shangxun.slice(0, 30);

    allData.shangxun = shangxun.map((item, index) => ({
        url: item.base62Id ? `https://canews.ifeng.com/c/${item.base62Id}` : formatUrl(item.url),
        thumbnails:
            item.thumbnails && item.thumbnails.image && item.thumbnails.image[0]
                ? formatImage(item.thumbnails.image[0].url, 150, 0)
                : '',
        title: item.title || '',
        summary: item.summary || item.title || '',
        newsTime: item.newsTime || '',
        commentUri: item.commentUrl,
        commentUrl: `https://gentie.ifeng.com/view.html?docUrl=${item.commentUrl}&docName=${item.title}&skey=${
            item.skey
        }`,
        commentNum: '',
    }));
} catch (error) {
    console.error(error);
}

ReactDOM.render(<Layout content={allData} />, document.getElementById('root'));
/* eslint-enable */
